module.exports = __webpack_public_path__ + "media/images/single10-6d27e65cf0b789c80847c41b9fe7f6da.jpg";